import React from 'react';
import { Star } from 'lucide-react';

export const Stars = ({ value = 0, size = 14, className = '' }) => (
  <span className={`inline-flex items-center gap-0.5 ${className}`} aria-label={`${value} sur 5`}>
    {[1, 2, 3, 4, 5].map((n) => (
      <Star
        key={n}
        size={size}
        className={n <= Math.round(value) ? 'fill-amber-400 text-amber-400' : 'text-slate-600'}
        strokeWidth={1.5}
      />
    ))}
  </span>
);

export default Stars;
